import { TiTick } from "react-icons/ti";
import bannerImg from "@assets/images/mobile-app-development-icon.avif";
// import bannerImg from '@assets/images/mobile-app-development-iconn.png'
import RippleButton from "@components/RippleAnimation";
import { motion } from "framer-motion";
import { Head } from "vite-react-ssg";
// import "./index.css";
export const Banner = () => {
  return (
    <>
      <Head>
        <title>Mobile App Development Company in Great Falls, VA</title>
        <meta
          name="description"
          content="Brainstorm, prototype and deploy with the best mobile app developers in Great Falls, VA. We offer full-spectrum mobile app development services."
        />
        <link
          rel="canonical"
          href="https://apptalyst.com/mobile-app-development"
        />
      </Head>
      {/* <div className=" bg-gradient-to-br from-[#6D1349] to-[#DF73FF] h-[80vh]  md:h-[38rem] "> */}
      <section className=" bg-[#f3ebfa] h-full py-20 lg:py-20 flex flex-col justify-center items-center  ">
        <div className="container relative    flex  flex-col md:flex-row space-y-8  md:space-y-0 mt-9 md:mt-12">
          <div className=" text-dark   flex  items-center    h-full md:w-9/12 lg:w-8/12  xl:w-11/12 ">
            <div className=" space-y-7 md:space-y-6">
              <motion.h1
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="block text-[25px]  lg:text-[30px] xl:text-[40px] 2xl:text-[40px] leading-[1.1] font-bold  text-dark  "
              >
                <span>Best Mobile App Development Services </span>
                <span  className=" sm:block">
                  in <span>Great Falls,</span>
                  Virginia{" "}
                </span>
              </motion.h1>
              <div className="  ">
                <h2 className="mobile-word-spacing block text-[18px] lg:text-[20px] xl:text-[25px] 2xl:text-[24px] leading-[1] text-dark ">
                  {" "}
                  We help businesses and innovators turn ideas into powerful
                  mobile applications.
                </h2>
              </div> 
              <div className="space-y-4 ">
                <ul className="space-y-0 text-dark">
                  <li className="flex items-start  md:items-start  text-base leading-[1.625rem]">
                    <span className="text-dark mr-2 bg-[#FFC067]  rounded-full p-0.5 mt-1 md:mt-1">
                      <TiTick />
                    </span> 
                    Developing innovative solutions with future-proof and
                    emerging technologies to solve real-world problems
                    effectively.
                  </li>
                  <li className="flex items-start  md:items-start  text-base leading-[1.625rem]">
                    <span className="text-dark mr-2 bg-[#FFC067]  rounded-full p-0.5 mt-1 md:mt-1">
                      <TiTick />
                    </span>
                    Bringing a collaborative experience with our expert
                    professionals, to turn business ideas into successful
                    products.
                  </li>
                  <li className="flex items-start  md:items-start  text-base leading-[1.625rem]">
                    <span className="text-dark mr-2 bg-[#FFC067]  rounded-full p-0.5 mt-1 md:mt-1">
                      <TiTick />
                    </span>
                    Quickly deploying and scaling functional prototypes and
                    Minimal Viable Products to test market fit and secure
                    funding.
                  </li>
                </ul>
                <div>
                  <RippleButton />
                </div>
              </div>

              {/* <div>
                <GetAQuoteButton  text="Get Started"/>
                </div> */}
            </div>
          </div>
          <div className=" md:w-4/12 lg:w-4/12 xl:w-5/12 flex justify-end mx-auto md:ml-auto items-center">
            <img
              src={bannerImg}
              alt="Nobile app development icon"
              className="w-[15rem] sm:w-[19rem] lg:w-[18rem] xl:w-[20rem] 2xl:w-[22rem] "
            />
          </div>
        </div>
      </section>
    </>
  );
};
